import Badge from "@common/controls/Badge/component";
import { SystemColor } from "@common/declarations";
import { sort } from "@common/lib/array";
import date from "@common/lib/date";
import { type I18n, i18nFormat } from "@common/lib/i18n";
import Network from "@common/modules/network/types";
import React from "react";

export const getCompetitionBadge = (i18n: I18n, competition: Network.Incentives.Incentive) => {
  const currentDate = date.getCurrentLocalDate();
  const startDate = date.startOfDay(competition.startDate);
  const endDate = date.startOfDay(competition.endDate);

  if (currentDate < startDate) {
    const dateDifference = date.differenceInDays(startDate, currentDate) + 1;
    return (
      <Badge color={SystemColor.Gray}>
        {dateDifference === 1 ? i18n.infoStartsInOneDay : i18nFormat(i18n.infoStartsInNDays, ["N", dateDifference])}
      </Badge>
    );
  }

  if (currentDate > endDate) return <Badge color={SystemColor.Gray}>{i18n.ended}</Badge>;

  const dateDifference = date.differenceInDays(endDate, currentDate) + 1;
  return (
    <Badge color={SystemColor.Orange}>
      {dateDifference === 1 ? i18n.infoEndsInOneDay : i18nFormat(i18n.infoEndsInNDays, ["N", dateDifference])}
    </Badge>
  );
};

export const adjustCycleOptionsDisplay = (i18n: I18n, options: Network.Cycles.Api.CycleOption[]) =>
  sort(options, { key: "value", order: "desc", type: "date" }).map((x, i) => ({
    ...x,
    label: i === 0 ? i18n.thisCycle : `${i18n.cycle} ${x.label}`
  }));
